module.exports = __webpack_public_path__ + "static/media/LifeSavingRules.a801c530.png";